export const getApiKey = () => process.env.REACT_APP_API_KEY;
export const getServer = () => process.env.REACT_APP_API_URL;
